// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__tGdv2","loadingText":"styles_loadingText__bmiVB","textContainer":"styles_textContainer__FBzUp"};